import dom from "../../../dist/jsx-render/dom"
import { ColumnBase } from "./ColumnBase";

export class ColumnExportIcon extends ColumnBase {

    public getContent(row: any): HTMLElement {
        return <i className="fal fa-file-export"></i>;
    }

    public createCell(rowModel: any, idField: string): HTMLElement {
        const cell = super.createCell(rowModel, idField);
        cell.classList.add("mt-export-icon");
        cell.classList.add("pointer");
        cell.setAttribute("data-id", rowModel[idField]);
        cell.addEventListener("click", this.onExportIconClicked);
        return cell;
    }
    onExportIconClicked = (ev: MouseEvent) => {
        if (this.table.props.onExportIconClicked) {
            ev.stopPropagation();
            this.table.props.onExportIconClicked((ev.currentTarget as HTMLElement).getAttribute("data-id"));
            
        }
    }

}